import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { SettingsMasterStep, StepIndexSMART, StepIndexZota, } from './type';
import { Typography } from '@mui/material';
export const cardSpecSMART = {
    [SettingsMasterStep.DigitalBus]: {
        name: SettingsMasterStep.DigitalBus,
        parent_id: StepIndexSMART.first,
        child_id: () => StepIndexSMART.second,
        title: 'Управление через адаптер цифровых шин',
        description: () => (_jsxs(_Fragment, { children: [_jsx(Typography, { component: "span", color: "textPrimary", children: "\u041A\u043E\u043D\u0442\u0440\u043E\u043B\u043B\u0435\u0440 \u0431\u0443\u0434\u0435\u0442 \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u044B\u0432\u0430\u0442\u044C \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u0443 \u0442\u0435\u043F\u043B\u043E\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F \u0434\u043B\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0440\u0435\u0436\u0438\u043C\u0430 \u043E\u0442\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u044C \u0432 \u043A\u043E\u0442\u0451\u043B. \u042D\u0442\u0430 \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u0430 \u0431\u0443\u0434\u0435\u0442 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0442\u044C\u0441\u044F \u043A\u043E\u0442\u043B\u043E\u043C \u0437\u0430 \u0441\u0447\u0435\u0442 \u0444\u0443\u043D\u043A\u0446\u0438\u0438 \u043C\u043E\u0434\u0443\u043B\u044F\u0446\u0438\u0438." }), _jsx("br", {}), _jsx(Typography, { component: "span", color: "error", children: "\u0410\u0434\u0430\u043F\u0442\u0435\u0440 \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E!" })] })),
        percent: 10,
    },
    [SettingsMasterStep.Relay]: {
        name: SettingsMasterStep.Relay,
        parent_id: StepIndexSMART.first,
        child_id: () => StepIndexSMART.sixth,
        title: 'Управление через клеммы ком­нат­но­го тер­мос­та­та котла',
        description: () => 'Контроллер будет замыкать и размыкать контакты своего релейного выхода, управляя\n' +
            'включением и выключением котла как комнатный термостат. Котел при нагреве будет ограничен\n' +
            'температурой теплоносителя, заданной его органами управления.',
        percent: 70,
    },
    [SettingsMasterStep.BoilerModel]: {
        name: SettingsMasterStep.BoilerModel,
        parent_id: StepIndexSMART.second,
        child_id: () => StepIndexSMART.third,
        title: '',
        description: () => '',
        percent: 15,
    },
    [SettingsMasterStep.GasBoiler]: {
        name: SettingsMasterStep.GasBoiler,
        parent_id: StepIndexSMART.third,
        child_id: () => StepIndexSMART.fourth,
        title: 'Газовый котёл',
        description: () => 'Выбрать, если в качестве источника тепла используется газовый котёл.',
        percent: 40,
    },
    [SettingsMasterStep.ElectricalBoiler]: {
        name: SettingsMasterStep.ElectricalBoiler,
        parent_id: StepIndexSMART.third,
        child_id: () => StepIndexSMART.fourth,
        title: 'Электри­чес­кий котёл',
        description: () => 'Выбрать, если в качестве источника тепла используется электрический котёл',
        percent: 40,
    },
    [SettingsMasterStep.BoilerDHW]: {
        name: SettingsMasterStep.BoilerDHW,
        parent_id: StepIndexSMART.fourth,
        child_id: () => StepIndexSMART.fifth,
        title: 'Газовый котёл с ГВС',
        description: () => 'Выбрать, если котёл системы отопления выполняет функцию приготовления горячей воды.',
        percent: 55,
    },
    [SettingsMasterStep.BoilerNoDHW]: {
        name: SettingsMasterStep.BoilerNoDHW,
        parent_id: StepIndexSMART.fourth,
        child_id: () => StepIndexSMART.sixth,
        title: 'Газовый котёл без ГВС',
        description: () => 'Выбрать, если контура ГВС нет или функцию приготовления горячей воды выполняет\n' +
            'независимый бойлер.',
        percent: 70,
    },
    [SettingsMasterStep.SingleCircuit]: {
        name: SettingsMasterStep.SingleCircuit,
        parent_id: StepIndexSMART.fifth,
        child_id: () => StepIndexSMART.sixth,
        title: 'Бойлер косвенного нагрева',
        description: () => 'Выбрать, если котёл системы отопления управляет БКН.',
        percent: 70,
    },
    [SettingsMasterStep.DoubleCircuit]: {
        name: SettingsMasterStep.DoubleCircuit,
        parent_id: StepIndexSMART.fifth,
        child_id: () => StepIndexSMART.sixth,
        title: 'Вторичный плас­тин­ча­тый теп­ло­об­мен­ник',
        description: () => 'Выбрать, если котёл нагревает ГВС через вторичный пластинчатый теплообменник.',
        percent: 70,
    },
    [SettingsMasterStep.AirControl]: {
        name: SettingsMasterStep.AirControl,
        parent_id: StepIndexSMART.sixth,
        child_id: (path) => {
            const isRelay = path.includes(SettingsMasterStep.Relay);
            if (isRelay) {
                return StepIndexSMART.ninth;
            }
            else {
                return StepIndexSMART.eighth;
            }
        },
        title: 'По тем­пе­ра­ту­ре воздуха',
        description: () => (_jsxs(_Fragment, { children: [_jsx(Typography, { component: "span", color: "textPrimary", children: "\u041A\u043E\u043D\u0442\u0440\u043E\u043B\u043B\u0435\u0440 \u0431\u0443\u0434\u0435\u0442 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u043E\u0442\u043E\u043F\u043B\u0435\u043D\u0438\u0435\u043C \u043F\u043E \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u0435 \u0432\u043E\u0437\u0434\u0443\u0445\u0430 \u0432 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0438." }), _jsx("br", {}), _jsx(Typography, { component: "span", color: "textSecondary", children: "\u0414\u0430\u0442\u0447\u0438\u043A \u0438\u0437 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430 \u043F\u043E\u0441\u0442\u0430\u0432\u043A\u0438 \u043D\u0443\u0436\u043D\u043E \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0434\u043B\u044F \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044F \u0442\u0435\u043A\u0443\u0449\u0435\u0439 \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u044B \u0432\u043E\u0437\u0434\u0443\u0445\u0430." })] })),
        percent: 85,
    },
    [SettingsMasterStep.WithPIDRegulation]: {
        name: SettingsMasterStep.WithPIDRegulation,
        parent_id: StepIndexSMART.eighth,
        child_id: () => StepIndexSMART.ninth,
        title: 'Плавное ПИД-регу­ли­ро­ва­ние',
        description: () => 'Контроллер будет управлять отоплением по расчетной температуре теплоносителя,\n' +
            'оптимальной для поддержания целевой температуры воздуха в помещении.',
        percent: 100,
    },
    [SettingsMasterStep.WithoutPIDRegulation]: {
        name: SettingsMasterStep.WithoutPIDRegulation,
        parent_id: StepIndexSMART.eighth,
        child_id: () => StepIndexSMART.ninth,
        title: 'Вкл/Выкл с заданной тем­пе­ра­ту­рой',
        description: () => 'Контроллер будет управлять отоплением по фиксированной температуре\n' +
            'теплоносителя (заданной настройкой котла), обеспечивая поддержание \n' +
            'целевой температуры воздуха в помещении.',
        percent: 100,
    },
    [SettingsMasterStep.WaterControl]: {
        name: SettingsMasterStep.WaterControl,
        parent_id: StepIndexSMART.sixth,
        child_id: () => StepIndexSMART.ninth,
        title: 'По тем­пе­ра­ту­ре тепло­но­си­те­ля',
        description: (path) => {
            const isRelay = path.includes(SettingsMasterStep.Relay);
            const message = 'Контроллер будет управлять отоплением по температуре теплоносителя.';
            if (isRelay) {
                return (_jsxs(_Fragment, { children: [_jsx(Typography, { component: "span", color: "textPrimary", children: message }), _jsx("br", {}), _jsx(Typography, { component: "span", color: "textSecondary", children: "\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0434\u0430\u0442\u0447\u0438\u043A \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u044B \u0442\u0435\u043F\u043B\u043E\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F \u043D\u0430 \u0442\u0440\u0443\u0431\u0435 \u043F\u043E\u0434\u0430\u0447\u0438 \u0442\u0435\u043F\u043B\u043E\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u043E\u0442\u043E\u043F\u043B\u0435\u043D\u0438\u044F." }), _jsx("br", {}), _jsx(Typography, { component: "span", color: "error", children: "\u0414\u0430\u0442\u0447\u0438\u043A \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E!" })] }));
            }
            return (_jsxs(_Fragment, { children: [_jsx(Typography, { component: "span", color: "textPrimary", children: message }), _jsx("br", {}), _jsx(Typography, { component: "span", color: "textSecondary", children: "\u0411\u0443\u0434\u0435\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D \u0434\u0430\u0442\u0447\u0438\u043A \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u044B \u0442\u0435\u043F\u043B\u043E\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F \u0432\u043D\u0443\u0442\u0440\u0438 \u043A\u043E\u0442\u043B\u0430." })] }));
        },
        percent: 100,
    },
    [SettingsMasterStep.PZAControl]: {
        name: SettingsMasterStep.PZAControl,
        parent_id: StepIndexSMART.sixth,
        child_id: (path) => {
            const isRelay = path.includes(SettingsMasterStep.Relay);
            if (isRelay) {
                return StepIndexSMART.sixth;
            }
            else {
                return StepIndexSMART.eighth;
            }
        },
        title: 'Погодо­за­ви­си­мое управ­ле­ние',
        description: (path) => {
            const isRelay = path.includes(SettingsMasterStep.Relay);
            const message = 'Контроллер будет управлять отоплением с учетом изменения погоды.';
            if (isRelay) {
                return (_jsxs(_Fragment, { children: [_jsx(Typography, { component: "span", color: "textPrimary", children: message }), _jsx("br", {}), _jsx(Typography, { component: "span", color: "textSecondary", children: "\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0434\u0430\u0442\u0447\u0438\u043A \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u044B \u0442\u0435\u043F\u043B\u043E\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F \u043D\u0430 \u0442\u0440\u0443\u0431\u0435 \u043F\u043E\u0434\u0430\u0447\u0438 \u0442\u0435\u043F\u043B\u043E\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u043E\u0442\u043E\u043F\u043B\u0435\u043D\u0438\u044F." }), _jsx("br", {}), _jsx(Typography, { component: "span", color: "error", children: "\u0414\u0430\u0442\u0447\u0438\u043A \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E!" })] }));
            }
            return (_jsxs(_Fragment, { children: [_jsx(Typography, { component: "span", color: "textPrimary", children: message }), _jsx("br", {}), _jsx(Typography, { component: "span", color: "textSecondary", children: "\u0411\u0443\u0434\u0435\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D \u0434\u0430\u0442\u0447\u0438\u043A \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u044B \u0442\u0435\u043F\u043B\u043E\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F \u0432\u043D\u0443\u0442\u0440\u0438 \u043A\u043E\u0442\u043B\u0430." })] }));
        },
        percent: 85,
    },
    [SettingsMasterStep.InRoomTemp]: {
        name: SettingsMasterStep.InRoomTemp,
        parent_id: StepIndexSMART.eighth,
        child_id: () => StepIndexSMART.ninth,
        title: 'С учетом комнатной температуры',
        description: () => 'Контроллер будет управлять отоплением по температуре теплоносителя, вычисленной\n' +
            'алгоритмом ПЗА с учетом изменения погоды. В помещении при этом поддерживается целевая\n' +
            'температура воздуха.',
        percent: 100,
    },
    [SettingsMasterStep.OutRoomTemp]: {
        name: SettingsMasterStep.OutRoomTemp,
        parent_id: StepIndexSMART.eighth,
        child_id: () => StepIndexSMART.ninth,
        title: 'Без учета комнатной температуры',
        description: () => 'Контроллер будет управлять отоплением по температуре теплоносителя, вычисленной\n' +
            'алгоритмом ПЗА с учетом изменения погоды.',
        percent: 100,
    },
    [SettingsMasterStep.SavedSetting]: {
        name: SettingsMasterStep.SavedSetting,
        parent_id: StepIndexSMART.ninth,
        child_id: () => StepIndexSMART.ninth,
        title: 'Сохранить настройки',
        description: () => 'Выбранные Вами настройки будут применены после автоматической перезагрузки контроллера.',
        percent: 100,
    },
    [SettingsMasterStep.NoSavedSetting]: {
        name: SettingsMasterStep.NoSavedSetting,
        parent_id: StepIndexSMART.ninth,
        child_id: () => StepIndexSMART.ninth,
        title: 'Выйти без сох­ра­не­ния',
        description: () => 'Выбранные Вами настройки не сохранятся.',
        percent: 100,
    },
};
export const cardSpecZota = {
    [SettingsMasterStep.BoilerModel]: {
        name: SettingsMasterStep.BoilerModel,
        parent_id: StepIndexZota.first,
        child_id: () => StepIndexZota.second,
        title: 'Модель котла',
        description: () => '',
        percent: 10,
    },
    [SettingsMasterStep.DigitalBus]: {
        name: SettingsMasterStep.DigitalBus,
        parent_id: StepIndexZota.second,
        child_id: () => StepIndexZota.third,
        title: 'Управление через адаптер цифровых шин',
        description: () => (_jsxs(_Fragment, { children: [_jsx(Typography, { component: "span", color: "textPrimary", children: "\u041A\u043E\u043D\u0442\u0440\u043E\u043B\u043B\u0435\u0440 \u0431\u0443\u0434\u0435\u0442 \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u044B\u0432\u0430\u0442\u044C \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u0443 \u0442\u0435\u043F\u043B\u043E\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F \u0434\u043B\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0440\u0435\u0436\u0438\u043C\u0430 \u043E\u0442\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u044C \u0432 \u043A\u043E\u0442\u0451\u043B. \u042D\u0442\u0430 \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u0430 \u0431\u0443\u0434\u0435\u0442 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0442\u044C\u0441\u044F \u043A\u043E\u0442\u043B\u043E\u043C \u0437\u0430 \u0441\u0447\u0435\u0442 \u0444\u0443\u043D\u043A\u0446\u0438\u0438 \u043C\u043E\u0434\u0443\u043B\u044F\u0446\u0438\u0438." }), _jsx("br", {}), _jsx(Typography, { component: "span", color: "error", children: "\u0410\u0434\u0430\u043F\u0442\u0435\u0440 \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E!" })] })),
        percent: 25,
    },
    [SettingsMasterStep.Relay]: {
        name: SettingsMasterStep.Relay,
        parent_id: StepIndexZota.second,
        child_id: () => StepIndexZota.sixth,
        title: 'Управление через клеммы ком­нат­но­го тер­мос­та­та котла',
        description: () => 'Контроллер будет замыкать и размыкать контакты своего релейного выхода, управляя\n' +
            'включением и выключением котла как комнатный термостат. Котел при нагреве будет ограничен\n' +
            'температурой теплоносителя, заданной его органами управления.',
        percent: 70,
    },
    [SettingsMasterStep.GasBoiler]: {
        name: SettingsMasterStep.GasBoiler,
        parent_id: StepIndexZota.third,
        child_id: () => StepIndexZota.fourth,
        title: 'Газовый котёл',
        description: () => 'Выбрать, если в качестве источника тепла используется газовый котёл.',
        percent: 40,
    },
    [SettingsMasterStep.ElectricalBoiler]: {
        name: SettingsMasterStep.ElectricalBoiler,
        parent_id: StepIndexZota.third,
        child_id: () => StepIndexZota.fourth,
        title: 'Электри­чес­кий котёл',
        description: () => 'Выбрать, если в качестве источника тепла используется электрический котёл',
        percent: 40,
    },
    [SettingsMasterStep.BoilerDHW]: {
        name: SettingsMasterStep.BoilerDHW,
        parent_id: StepIndexZota.fourth,
        child_id: () => StepIndexZota.fifth,
        title: 'Газовый котёл с ГВС',
        description: () => 'Выбрать, если котёл системы отопления выполняет функцию приготовления горячей воды.',
        percent: 55,
    },
    [SettingsMasterStep.BoilerNoDHW]: {
        name: SettingsMasterStep.BoilerNoDHW,
        parent_id: StepIndexZota.fourth,
        child_id: () => StepIndexZota.sixth,
        title: 'Газовый котёл без ГВС',
        description: () => 'Выбрать, если контура ГВС нет или функцию приготовления горячей воды выполняет\n' +
            'независимый бойлер.',
        percent: 70,
    },
    [SettingsMasterStep.SingleCircuit]: {
        name: SettingsMasterStep.SingleCircuit,
        parent_id: StepIndexZota.fifth,
        child_id: () => StepIndexZota.sixth,
        title: 'Бойлер косвенного нагрева',
        description: () => 'Выбрать, если котёл системы отопления управляет БКН.',
        percent: 70,
    },
    [SettingsMasterStep.DoubleCircuit]: {
        name: SettingsMasterStep.DoubleCircuit,
        parent_id: StepIndexZota.fifth,
        child_id: () => StepIndexZota.sixth,
        title: 'Вторичный плас­тин­ча­тый теп­ло­об­мен­ник',
        description: () => 'Выбрать, если котёл нагревает ГВС через вторичный пластинчатый теплообменник.',
        percent: 70,
    },
    [SettingsMasterStep.AirControl]: {
        name: SettingsMasterStep.AirControl,
        parent_id: StepIndexZota.sixth,
        child_id: (path) => {
            const isRelay = path.includes(SettingsMasterStep.Relay);
            if (isRelay) {
                return StepIndexZota.ninth;
            }
            else {
                return StepIndexZota.seventh;
            }
        },
        title: 'По тем­пе­ра­ту­ре воздуха',
        description: () => (_jsxs(_Fragment, { children: [_jsx(Typography, { component: "span", color: "textPrimary", children: "\u041A\u043E\u043D\u0442\u0440\u043E\u043B\u043B\u0435\u0440 \u0431\u0443\u0434\u0435\u0442 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0442\u044C \u043E\u0442\u043E\u043F\u043B\u0435\u043D\u0438\u0435\u043C \u043F\u043E \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u0435 \u0432\u043E\u0437\u0434\u0443\u0445\u0430 \u0432 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0438." }), _jsx("br", {}), _jsx(Typography, { component: "span", color: "textSecondary", children: "\u0414\u0430\u0442\u0447\u0438\u043A \u0438\u0437 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430 \u043F\u043E\u0441\u0442\u0430\u0432\u043A\u0438 \u043D\u0443\u0436\u043D\u043E \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0434\u043B\u044F \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044F \u0442\u0435\u043A\u0443\u0449\u0435\u0439 \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u044B \u0432\u043E\u0437\u0434\u0443\u0445\u0430." })] })),
        percent: 85,
    },
    [SettingsMasterStep.WithPIDRegulation]: {
        name: SettingsMasterStep.WithPIDRegulation,
        parent_id: StepIndexZota.seventh,
        child_id: () => StepIndexZota.ninth,
        title: 'Плавное ПИД-регу­ли­ро­ва­ние',
        description: () => 'Контроллер будет управлять отоплением по расчетной температуре теплоносителя,\n' +
            'оптимальной для поддержания целевой температуры воздуха в помещении.',
        percent: 100,
    },
    [SettingsMasterStep.WithoutPIDRegulation]: {
        name: SettingsMasterStep.WithoutPIDRegulation,
        parent_id: StepIndexZota.seventh,
        child_id: () => StepIndexZota.ninth,
        title: 'Вкл/Выкл с заданной тем­пе­ра­ту­рой',
        description: () => 'Контроллер будет управлять отоплением по фиксированной температуре\n' +
            'теплоносителя (заданной настройкой котла), обеспечивая поддержание \n' +
            'целевой температуры воздуха в помещении.',
        percent: 100,
    },
    [SettingsMasterStep.WaterControl]: {
        name: SettingsMasterStep.WaterControl,
        parent_id: StepIndexZota.sixth,
        child_id: () => StepIndexZota.ninth,
        title: 'По тем­пе­ра­ту­ре тепло­но­си­те­ля',
        description: (path) => {
            const isRelay = path.includes(SettingsMasterStep.Relay);
            const message = 'Контроллер будет управлять отоплением по температуре теплоносителя.';
            if (isRelay) {
                return (_jsxs(_Fragment, { children: [_jsx(Typography, { component: "span", color: "textPrimary", children: message }), _jsx("br", {}), _jsx(Typography, { component: "span", color: "textSecondary", children: "\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0434\u0430\u0442\u0447\u0438\u043A \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u044B \u0442\u0435\u043F\u043B\u043E\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F \u043D\u0430 \u0442\u0440\u0443\u0431\u0435 \u043F\u043E\u0434\u0430\u0447\u0438 \u0442\u0435\u043F\u043B\u043E\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u043E\u0442\u043E\u043F\u043B\u0435\u043D\u0438\u044F." }), _jsx("br", {}), _jsx(Typography, { component: "span", color: "error", children: "\u0414\u0430\u0442\u0447\u0438\u043A \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E!" })] }));
            }
            return (_jsxs(_Fragment, { children: [_jsx(Typography, { component: "span", color: "textPrimary", children: message }), _jsx("br", {}), _jsx(Typography, { component: "span", color: "textSecondary", children: "\u0411\u0443\u0434\u0435\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D \u0434\u0430\u0442\u0447\u0438\u043A \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u044B \u0442\u0435\u043F\u043B\u043E\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F \u0432\u043D\u0443\u0442\u0440\u0438 \u043A\u043E\u0442\u043B\u0430." })] }));
        },
        percent: 100,
    },
    [SettingsMasterStep.PZAControl]: {
        name: SettingsMasterStep.PZAControl,
        parent_id: StepIndexZota.sixth,
        child_id: (path) => {
            const isRelay = path.includes(SettingsMasterStep.Relay);
            if (isRelay) {
                return StepIndexZota.ninth;
            }
            else {
                return StepIndexZota.eighth;
            }
        },
        title: 'Погодо­за­ви­си­мое управ­ле­ние',
        description: (path) => {
            const isRelay = path.includes(SettingsMasterStep.Relay);
            const message = 'Контроллер будет управлять отоплением с учетом изменения погоды.';
            if (isRelay) {
                return (_jsxs(_Fragment, { children: [_jsx(Typography, { component: "span", color: "textPrimary", children: message }), _jsx("br", {}), _jsx(Typography, { component: "span", color: "textSecondary", children: "\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0434\u0430\u0442\u0447\u0438\u043A \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u044B \u0442\u0435\u043F\u043B\u043E\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F \u043D\u0430 \u0442\u0440\u0443\u0431\u0435 \u043F\u043E\u0434\u0430\u0447\u0438 \u0442\u0435\u043F\u043B\u043E\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u043E\u0442\u043E\u043F\u043B\u0435\u043D\u0438\u044F." }), _jsx("br", {}), _jsx(Typography, { component: "span", color: "error", children: "\u0414\u0430\u0442\u0447\u0438\u043A \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E!" })] }));
            }
            return (_jsxs(_Fragment, { children: [_jsx(Typography, { component: "span", color: "textPrimary", children: message }), _jsx("br", {}), _jsx(Typography, { component: "span", color: "textSecondary", children: "\u0411\u0443\u0434\u0435\u0442 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D \u0434\u0430\u0442\u0447\u0438\u043A \u0442\u0435\u043C\u043F\u0435\u0440\u0430\u0442\u0443\u0440\u044B \u0442\u0435\u043F\u043B\u043E\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044F \u0432\u043D\u0443\u0442\u0440\u0438 \u043A\u043E\u0442\u043B\u0430." })] }));
        },
        percent: 85,
    },
    [SettingsMasterStep.InRoomTemp]: {
        name: SettingsMasterStep.InRoomTemp,
        parent_id: StepIndexZota.eighth,
        child_id: () => StepIndexZota.ninth,
        title: 'С учетом комнатной температуры',
        description: () => 'Контроллер будет управлять отоплением по температуре теплоносителя, вычисленной\n' +
            'алгоритмом ПЗА с учетом изменения погоды. В помещении при этом поддерживается целевая\n' +
            'температура воздуха.',
        percent: 100,
    },
    [SettingsMasterStep.OutRoomTemp]: {
        name: SettingsMasterStep.OutRoomTemp,
        parent_id: StepIndexZota.eighth,
        child_id: () => StepIndexZota.ninth,
        title: 'Без учета комнатной температуры',
        description: () => 'Контроллер будет управлять отоплением по температуре теплоносителя, вычисленной\n' +
            'алгоритмом ПЗА с учетом изменения погоды.',
        percent: 100,
    },
    [SettingsMasterStep.SavedSetting]: {
        name: SettingsMasterStep.SavedSetting,
        parent_id: StepIndexZota.ninth,
        child_id: () => StepIndexZota.ninth,
        title: 'Сохранить настройки',
        description: () => 'Выбранные Вами настройки будут применены после автоматической перезагрузки контроллера.',
        percent: 100,
    },
    [SettingsMasterStep.NoSavedSetting]: {
        name: SettingsMasterStep.NoSavedSetting,
        parent_id: StepIndexZota.ninth,
        child_id: () => StepIndexZota.ninth,
        title: 'Выйти без сох­ра­не­ния',
        description: () => 'Выбранные Вами настройки не сохранятся.',
        percent: 100,
    },
};
export const cardSpec = {
    SMART: cardSpecSMART,
    Zota: cardSpecZota,
};
